export const accordion = () => {
  const accordions = document.querySelectorAll('.accordion-item');

  if (!accordions.length) {
    return;
  }

  const accordionClickHandler = (event, accordion) => {
    const header = accordion.querySelector('.accordion-item-header');
    const content = accordion.querySelector('.accordion-item-content');

    if (!(header && content)) {
      return;
    }

    if (header.classList.contains('expanded')) {
      header.classList.remove('expanded');
      content.style.maxHeight = null;
    } else {
      header.classList.add('expanded');
      content.style.maxHeight = content.scrollHeight + "px";
    }
  };

  accordions.forEach(accordion => {
    const header = accordion.querySelector('.accordion-item-header');
    const content = accordion.querySelector('.accordion-item-content');
    
    if (!(header && content)) {
      return;
    }

    if (!header.classList.contains('event-attached')) {
      header.addEventListener('click', (event) => accordionClickHandler(event, accordion));
      header.classList.add('event-attached');
    }

    if (header.classList.contains('expanded') && content) {
      content.style.maxHeight = content.scrollHeight + "px";
    }
  });
};
